<template>
  <el-card class="info-card">
    <font-awesome-icon :icon="icon" />
    <div class="info-block">
      <span>{{ text }}</span>
      <div
        v-if="loading"
        v-loading="loading"
        class="loading"
        element-loading-background="transparent"
      />
      <b v-else>${{ modelValue }}</b>
    </div>
  </el-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InfoBlock',
  props: {
    text: {
      type: String,
      required: true
    },
    modelValue: {
      type: [Number, String],
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: true
    }
  }
})
</script>
<style lang="scss" scoped>
.el-card {
  margin: 0 10px 10px 0;
}

:deep(.el-card__body) {
  text-align: center;
  padding: 10px 3px;
}

:deep(.info-block) {
  background-color: var(--el-color-white);
  overflow: hidden;
  color: var(--el-color-primary);
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;

  span {
    display: block;
    color: var(--el-text-color-primary);
  }

  b {
    color: #e65d6e;
  }
}

.loading {
  margin-top: 20px;
}

@media (max-width: 550px) {
  :deep(.info-block) {
    font-size: 10px;
    line-height: 2;
  }
}
</style>
